module.exports = __webpack_public_path__ + "static/media/logo-sejong@2x.626f62d9.png";